import type { SearchSuggestion } from '@rocco/ui/search/view-models/search-suggestion';

export const isCategorySuggestion = (
    suggestion: SearchSuggestion | string,
): suggestion is SearchSuggestion => {
    return typeof suggestion === 'object' && 'link' in suggestion;
};
